import { render } from "./InvitationForm.vue?vue&type=template&id=af46d630"
import script from "./InvitationForm.vue?vue&type=script&lang=js"
export * from "./InvitationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__